(function () {
  function initBuildOwnPackAudio(root) {
    var button = root.querySelector('[data-llp40-guide-audio-button]');
    var audio = root.querySelector('[data-llp40-guide-audio]');
    var icon = root.querySelector('[data-llp40-guide-audio-icon]');
    var progress = root.querySelector('[data-llp40-guide-audio-progress]');

    if (!button || !audio || !icon || !progress) return;

    var playIcon = icon.innerHTML;
    var isSeeking = false;
    var pauseIcon = [
      '<svg class="llp40-guide-audio__svg llp40-guide-audio__svg--pause" viewBox="0 0 24 24" focusable="false" aria-hidden="true">',
      '<rect fill="currentColor" x="7.8" y="5.2" width="3.2" height="13.6" rx="0.2"></rect>',
      '<rect fill="currentColor" x="13" y="5.2" width="3.2" height="13.6" rx="0.2"></rect>',
      '</svg>'
    ].join('');

    function setProgress(value) {
      progress.value = value;
      progress.style.setProperty('--llp40-guide-audio-progress', value + '%');
    }

    function updateProgress() {
      if (isSeeking || !audio.duration) return;
      setProgress((audio.currentTime / audio.duration) * 100);
    }

    button.addEventListener('click', function () {
      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () {
      root.classList.add('is-audio-active');
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', 'Pause 30-second build your pack guide');
      icon.innerHTML = pauseIcon;
    });

    audio.addEventListener('pause', function () {
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', 'Play 30-second build your pack guide');
      icon.innerHTML = playIcon;
    });

    audio.addEventListener('ended', function () {
      audio.currentTime = 0;
      root.classList.remove('is-audio-active');
      setProgress(0);
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', 'Play 30-second build your pack guide');
      icon.innerHTML = playIcon;
    });

    audio.addEventListener('timeupdate', updateProgress);
    audio.addEventListener('loadedmetadata', updateProgress);

    progress.addEventListener('input', function () {
      isSeeking = true;
      setProgress(progress.value);
      if (audio.duration) {
        audio.currentTime = (Number(progress.value) / 100) * audio.duration;
      }
    });

    progress.addEventListener('change', function () {
      isSeeking = false;
      updateProgress();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-llp40-guide-audio-root]').forEach(initBuildOwnPackAudio);
  });
})();
